module.exports = __webpack_public_path__ + "static/media/hearts-icon.9a04e71b.svg";